import React from 'react';
import { useTranslation } from 'react-i18next';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import Iconify from '../../theme/iconify/iconify';
import StatisticCard from "./StatisticCard";

function Statistics({ users }) {
    const { t } = useTranslation();

    const cards = [
        {
            icon: 'prime:users',
            label: t('users.card.total'),
            value: users.length,
            width: 48
        },
        {
            icon: 'mdi:administrator',
            label: t('users.card.admin'),
            value: users.filter(user => user.role === 'admin').length,
            width: 36
        },
        {
            icon: 'prime:user-plus',
            label: t('users.card.new'),
            value: users.filter(user => new Date(user.registration_date) >= new Date(new Date() - 7 * 24 * 60 * 60 * 1000)).length,
            width: 48
        },
        {
            icon: 'material-symbols:hub-outline',
            label: t('users.card.active'),
            value: users.filter(user => new Date(user.last_login) >= new Date(new Date() - 24 * 60 * 60 * 1000)).length,
            width: 36
        }
    ];

    return (
        <>
            <Grid container spacing={2} sx={{ mb: { xs: 3, md: 2 } }}>
                {cards.map((card, index) => (
                    <StatisticCard
                        key={index}
                        icon={card.icon}
                        label={card.label}
                        value={card.value}
                        width={card.width}
                    />
                ))}
            </Grid>
        </>
    );
}

export default Statistics;